export function formatNumber(value: number) {
    return value.toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function getLeastDistance(from: number, a: number, b: number) {
    return Math.abs(from - a) < Math.abs(from - b) ? a : b;
}

export function round(num: any) {
    return +(Math.round(parseFloat(num + 'e+2')) + 'e-2');
}